RivalIQ.apps.Companies.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const widgets = [
        {
            instanceId: 'companies',
            widgetId: RivalIQ.enums.widgetTypes.SOCIAL_CHANNEL_MATRIX
        }
    ];

    function isEmpty(propable) {
        const companyData = propable.dashboardModel.curation.companyData;
        return (_.size(companyData) === 0);
    }

    const Layout = Dashboard.views.Widgets.extend({
        panelView: Dashboard.views.DetailsLayout.extend({
            template: '#dashboardWidgetAlternateLargeRightActionsDetailLayoutTemplate',
            showLeftToolbarActions: _.noop,
            showToolbarActions: function () {
                const me = this;
                const isLimited = RivalIQ.state.account.hasLimitedLandscapeCapability();

                me.actions.show(new RivalIQ.views.Link({
                    className: _.compact([
                        'btn btn-primary',
                        (isLimited ? 'disabled' : null)
                    ]).join(' '),
                    linkName: '<span class="fa fa-plus"></span><span>Add Company</span>',
                    action: _.bind(me.showAddCompanyModal, me)
                }));

                const isLandscapeEmpty = isEmpty(me);

                me.actions.show(new RivalIQ.views.Link({
                    className: `btn btn-default${isLandscapeEmpty ? ' disabled' : ''}`,
                    linkName: '<span>Change Focus Company</span>',
                    action: _.bind(me.onChangeFocusCompanyClick, me)
                }), {
                    preventDestroy: true
                }
                );

                if (!isLandscapeEmpty && !isLimited) {
                    me.showExportDropdown();
                }
            },
            showAddCompanyModal: function () {
                RivalIQ.execute('landscape:company:add');
            },
            onChangeFocusCompanyClick: function () {
                const me = this;
                const companyData = me.dashboardModel.curation.companyData;
                RivalIQ.execute('show:modal', new App.views.ChangeFocusCompany({
                    collection: companyData,
                    model: new Backbone.Model({
                        activeModel: companyData.get(me.getProp('focusCompanyId'))
                    })
                }));
            }
        })
    });

    // NOTE exposed for testing
    const loadCompanyData = curations._loadCompanyData = function (curation) {
        // NOTE this is the only safe option: if we try to rely on the cache
        // layer we will have issues on add/remove as the cache layer
        // invalidates, removing the bootstrapped `companyData` entirely from
        // the cache
        // For more information see GitHub #16908, #18487, #18541
        curation.companyData = RivalIQ.state.landscape.get('companies');
    };

    // NOTE exposed for testing
    const setTags = curations._setTags = function (curation) {
        if (_.size(curation.companyData) !== 0) {
            return;
        }

        const components = _.defaults({
            companySets: {
                disabled: true
            }
        }, curation.getNavigationComponents());

        curation.requestAnimationFrame(function () {
            RivalIQ.apps.Shell.execute('set:components', components);
        });
    };

    curations.Companies = Dashboard.models.SingleWidgetCuration.extend({
        title: 'Companies',

        beforeFilters: [
            loadCompanyData,
            setTags
        ],

        widgetsView: Layout,
        widgetDefinitions: widgets,

        timePeriod: false
    });

});
